import { render, staticRenderFns } from "./VinculoUsuarioManage.vue?vue&type=template&id=f59397a6&scoped=true"
import script from "./VinculoUsuarioManage.vue?vue&type=script&lang=js"
export * from "./VinculoUsuarioManage.vue?vue&type=script&lang=js"
import style0 from "./VinculoUsuarioManage.vue?vue&type=style&index=0&id=f59397a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59397a6",
  null
  
)

export default component.exports